<audit-header
[auditCtrl]="auditCtrl"
[isExpanded]="twiddleState"
[caption]="caption"
[auditStatus]="auditTypeSummary"
[refresh]="getOpenRunAllAuditsModal"
[auditStatusConfig]="auditStatusConfig"
[readOnly]="isReadOnly()"
>
</audit-header>
<table class="audit-table">
<!-- Brought over from ABED before each audit was hard coded now they are generated programatically -->
  <ng-container *ngIf="twiddleState.value">
    <ng-container *ngFor="let audit of audits; let idx = index">
      <tr *ngIf="!audit.isHidden && !hiddenAudits[audit.slug] && isAuditShownByText(audit)" [class.is-disabled]="audit.isDisabled">
  
        <th class="audit-table-col-num"> {{idx + 1}} </th>
        <th class="audit-table-col-name"> 
          {{audit.caption[lang.c()]}} 
          <code *ngIf="showSlugs" class="audit-slug-tag">{{ audit.slug }}</code>
          <p *ngIf="auditCtrl.auditsWithError[audit.slug]" style="color: red; font-size: x-small;">Error Running
        </th>
        <th class="audit-table-col-btn">
          <div class="audit-table-run-audit-buttons">
            <button
              *ngFor="let scope of audit.itemScope"
              (click)="auditCtrl.runCustomAudit(audit.slug, scope, audit.isLangSensitive, audit.auditTarget)" 
              class="button is-small is-light"
              [class.is-info]="auditCtrl.auditsRunning[audit.slug]"
              [disabled]="audit.isDisabled || (auditCtrl.auditsRan[audit.slug] && auditCtrl.getAuditLog(audit.slug))|| isReadOnly() || auditCtrl.auditsRunning[audit.slug]" 
            > <tra [slug]="auditScopeDictionary[scope]"></tra> </button>
          </div>
        </th>
        <th style="border-width: 1px; width: 18em">
          <span style="display: flex; flex-direction: column;">
            <span *ngIf="auditCtrl.getAuditLog(audit.slug)">
              <table class="audit-log-list">
                <tr [style.color]="(auditCtrl.getAuditLog(audit.slug).is_new) ? 'green' : 'initial'">
                  <th><tra slug="pre_publish_audits_audited_on"></tra></th> 
                  <td>
                    {{auditCtrl.getAuditLog(audit.slug).audited_on | date:'short'}}
                  </td>
                </tr>
                <tr>
                  <th><tra slug="pre_publish_audits_audited_by"></tra></th>
                  <td>
                    {{auditCtrl.getAuditLog(audit.slug)?.name}}<br>
                    <a [href]="'mailto:'+ auditCtrl.getAuditLog(audit.slug)?.email">
                      {{auditCtrl.getAuditLog(audit.slug)?.email}}
                    </a>
                  </td>
                </tr>
                <tr [style.color]="getIssueColor(audit.slug)">
                  <th><tra slug="pre_publish_audits_number_of_issues"></tra></th> 
                  <td>{{getNumberOfIssues(audit.slug)}}</td>
                </tr>
              </table>
            </span>
            <span *ngIf="!auditCtrl.getAuditLog(audit.slug) && !auditCtrl.retrievingAuditLogs">
              <b><tra slug="pre_publish_audit_no_logs_found"></tra></b>
            </span>
            <span *ngIf="!auditCtrl.getAuditLog(audit.slug) && auditCtrl.retrievingAuditLogs">
              <b><i class="fa fa-spinner fa-spin" aria-hidden="true"></i></b>
            </span>
            <span *ngIf="auditCtrl.auditsRan[audit.slug]  && !auditCtrl.retrievingAuditLogs && auditCtrl.getAuditLog(audit.slug) " style="display: flex; justify-content: center;">
              <button  class="button is-small is-danger" (click)="auditCtrl.refreshAudit([audit.slug])" [disabled]="isReadOnly()" > 
                <span><tra slug="ie_refresh"></tra></span>
              </button>
            </span>
          </span>
        </th>
        <td class="audit-table-col-result">
          <button class="button is-small" *ngIf="auditCtrl.getAuditLog(audit.slug) && !auditCtrl.auditsRan[audit.slug]" (click)="auditCtrl.auditsRan[audit.slug] = true">
            <tra slug="pre_publish_audits_toggle_history"></tra>
          </button>
          <span *ngIf="auditCtrl.auditsRan[audit.slug] && auditCtrl.getAuditLog(audit.slug)">
            <p *ngIf="showIssues" style="padding-left: 1em; font-weight: bold;">
              <tra slug="pre_publish_audits_audited_on"></tra>&nbsp;{{auditCtrl.getAuditLog(audit.slug).audited_on | date:'short'}}
            </p>
            <p *ngIf="showIssues" style="padding-left: 1em;" [ngStyle]="{'color': getNumberOfIssues(audit.slug) ? 'red' : 'initial'}">
              <tra slug="ie_issues_detected"></tra>: {{getNumberOfIssues(audit.slug)}}&nbsp;
            </p>
            <ng-container *ngIf="isAuditRepairable(audit) && getNumberOfIssues(audit.slug) && showIssues && canAutoFix(audit.slug)">
              <div style="padding-left: 1em;">
                <ng-container *ngIf="currentItemRepairs(audit) as itemRepairs">
                  <button
                    *ngFor="let group of itemRepairs"
                    class="button is-small has-icon"
                    style="margin-right: 0.5em;"
                    [title]="'Run “' + repairName(group.repair) + '” on the open item only'"
                    (click)="autoFixCurrentItem(audit, group)"
                    [disabled]="isReadOnly()"
                  >
                    <span class="icon"><i class="fa fa-wrench" aria-hidden="true"></i> </span>
                    <span>{{ currentItemRepairLabel(group, itemRepairs.length) }}</span>
                  </button>
                </ng-container>
                <span *ngIf="repairProgress(audit) as progress">
                  <tra slug="ie_applying_auto_fix"></tra> {{progress.i}} / {{progress.n}}
                </span>
              </div>
            </ng-container>
    
            <ul *ngIf="!audit.isCustomResult">
              <ng-container *ngFor="let result of auditCtrl.auditQuestionMem[auditCtrl.getAuditResultSlug(audit.slug)]">
                <li *ngIf="!isCheckHidden(audit.slug, result.id) && isCheckShownByText(audit, result)">
                  <button 
                    class="button is-small has-icon" 
                    (click)="activateAuditItems(audit.slug, result.id, audit.auditTarget)" 
                    [class.is-info]="checkActiveQuestionMem(audit.slug, result.id)"
                    style="vertical-align: middle;"
                    [disabled]="!canSelectAuditQuestions(audit.slug,result.id)"
                  >
                    <span class="icon"><i class="fa fa-list" aria-hidden="true"></i> </span>
                    <span>{{result.items.length}}
                      <ng-container [ngSwitch]="audit.auditTarget">
                        <ng-container *ngSwitchCase="AuditTarget.MSCAT_PANELS">
                          <tra slug="ie_panel"></tra> 
                        </ng-container>
                        <ng-container *ngSwitchCase="AuditTarget.TLOFT_PANELS">
                          <tra slug="ie_panel"></tra> 
                        </ng-container>
                        <ng-container *ngSwitchCase="AuditTarget.LINEAR_SECTIONS">
                          <tra slug="ie_panel"></tra> 
                        </ng-container>
                        <ng-container *ngSwitchCase="AuditTarget.PANELS">
                          <tra slug="ie_panel"></tra> 
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                          <tra slug="ie_questions"></tra> 
                        </ng-container>
                      </ng-container>
                    </span>
                  </button>
                  <span [style]="result.items.length && !result.informativeOnly? 'color: red': ''">
                    {{result.caption}}
                  </span>
                  <code *ngIf="showSlugs && resultCheckId(result)" class="audit-slug-tag">{{ resultCheckId(result) }}</code>
                  <span *ngIf="getCollectedParamCodes(result).length" class="param-column-collector">
                    Columns: {{ getCollectedParamCodes(result).join(', ') }}
                    <button
                      type="button"
                      class="button is-small"
                      (click)="applyCollectedColumns(result); $event.stopPropagation()"
                    >Show these columns</button>
                  </span>
                  <button
                    *ngIf="hasCheckAutoFix(audit.slug, result.id) && hasCheckRepair(audit, result.id) && result.items.length"
                    type="button"
                    class="button is-small is-warning is-light audit-check-fix"
                    style="margin-left:1em;"
                    [title]="'Run “' + checkRepairName(audit, result.id) + '” on the ' + result.items.length + ' items in this check'"
                    [attr.aria-label]="'Run “' + checkRepairName(audit, result.id) + '” on the ' + result.items.length + ' items in this check'"
                    [disabled]="isReadOnly() || !canSelectAuditQuestions(audit.slug, result.id)"
                    (click)="runCheckAutoFix(audit, result.id)"
                  ><i class="fa fa-wrench" aria-hidden="true"></i></button>
                  <i *ngIf="hasCheckAutoFix(audit.slug, result.id) && !(hasCheckRepair(audit, result.id) && result.items.length)" class="fa fa-wrench" aria-hidden="true" style="margin-left:1em;"
                    [title]="checkRepairName(audit, result.id)"></i>
                </li>
              </ng-container>
            </ul>
    
            <ng-container *ngIf="audit.isCustomResult" >
              <div *ngIf="audit.isContentDiff">
                <div style="margin-left: 1em">
                  <h4 style="margin-bottom: 0;">{{auditCtrl.auditResultHeader[audit.slug]}}</h4>
                  <label style="display: flex; gap:0.2em"> Only show different content:
                    <!-- todo: consider attaching this model to a different object -->
                    <input  type="checkbox"  (click)="toggleIsAuditHideSameContent(audit.slug)" [checked]="getAuditHideSameContent(audit.slug)">
                  </label>
                </div>
                <ng-container *ngIf="auditCtrl.auditQuestionMem[audit.slug]?.length && audit.slug == 'CONTENT_DIFF_AUDIT'">
                  <div>
                    <button class="button is-small" [class.is-info]="!getAuditRanValue(audit.slug, 'isDiffEn') && !getAuditRanValue(audit.slug, 'isDiffFr')" (click)="toggleBothLangs(audit.slug)">EN | FR</button>
                    <button class="button is-small" [class.is-info]="getAuditRanValue(audit.slug, 'isDiffEn')" (click)="toggleDiff(audit.slug, 'en')">EN</button>
                    <button class="button is-small" [class.is-info]="getAuditRanValue(audit.slug, 'isDiffFr')" (click)="toggleDiff(audit.slug, 'fr')">FR</button>
                  </div>
                </ng-container>
                <ul>
                  <div *ngFor="let qDiff of auditCtrl.auditQuestionMem[audit.slug]" style="margin-bottom: 0.5em;">
                    <ng-container *ngIf="(getAuditHideSameContent(audit.slug) ? qDiff.hasDiff : true) && shouldShowDiffLang(audit.slug, qDiff.lang)">
                      <widget-item-diff
                        *ngIf="audit.slug == 'CONTENT_DIFF_AUDIT'"
                        [questionId]= "qDiff.questionId"
                        [questionLabel] = "qDiff.questionLabel"
                        [description] = "qDiff.description"
                        [content] = "qDiff.content"
                        [style] = "qDiff.style"
                        [currentContent]="qDiff.currentContent"
                        [previousContent]="qDiff.previousContent"
                        [itemBankCtrl]="auditCtrl.itemBankCtrl"
                        [lang] = "qDiff.lang"
                      >
                      </widget-item-diff>
                    <!-- 18 has not yet been updated, preserving old view -->
                      <expansion-panel
                        *ngIf="audit.slug != 'CONTENT_DIFF_AUDIT'"
                        [title]= "qDiff.title"
                        [subTitle] = "qDiff.subTitle"
                        [description] = "qDiff.description"
                        [content] = "qDiff.content"
                        [style] = "qDiff.style"
                      ></expansion-panel>
                    </ng-container>
                  </div>
                </ul>
              </div>
    
              <ng-container [ngSwitch]="audit.slug">
                <div *ngSwitchCase="'COMMENTS'">
                  <ul>
                    <li>
                      <div style="display: flex; align-items: center">
                        <button 
                        [class.is-info]="auditCtrl.checkActiveQuestionMem('COMMENTS_QS_W_OUTSTANDING_CMTS')"
                        (click)="auditCtrl.activateAuditQuestions('COMMENTS_QS_W_OUTSTANDING_CMTS')"
                        class="button is-small has-icon" 
                        [disabled]="!canSelectAuditQuestions(audit.slug, 'QS_W_OUTSTANDING_CMTS') || isReadOnly()"
                        >
                          <span class="icon"><i class="fa fa-list" aria-hidden="true"></i> </span>
                          <span>{{getAuditQMem(audit.slug, 'QS_W_OUTSTANDING_CMTS').length || 0}} items</span>
                        </button>  
                        <span>have outstanding comments</span>
                      </div>
                    </li>
                    <li>
                      <div style="display: flex; align-items: center">
                        <button 
                        class="button is-small has-icon" 
                        (click)="assetLibraryCtrl.openAssetLibraryToIds(auditCtrl.auditQuestionMem['COMMENTS_ASSETS_W_OUTSTANDING_CMTS'])"
                        [disabled]="!canSelectAuditQuestions(audit.slug, 'ASSETS_W_OUTSTANDING_CMTS') || isReadOnly()"
                        >
                          <span class="icon"><i class="fa fa-list" aria-hidden="true"></i> </span>
                          <span>{{getAuditQMem(audit.slug, 'ASSETS_W_OUTSTANDING_CMTS').length || 0}} assets</span>
                        </button>  
                        <span>have outstanding comments</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </ng-container>
    
            </ng-container>
          </span>
        </td>
      </tr>
    </ng-container>
  </ng-container>

</table>

<div class="custom-modal" *ngIf="cModal()">
  <div class="modal-contents">
    <div class="modal-header">
      <tra [slug]="caption"></tra> ({{runAsync? 'All' : 'Quick'}})
    </div>
    <div class="modal-message">
      <div>
        <tra [slug]="runAsync ? 'ie_audit_bulk_run_async' : 'ie_audit_bulk_run_sync'"></tra>
      </div>
      <div style="font-style: italic;">
        <tra slug="lbl_modal_auto_close_completion"></tra>
        <ng-container *ngIf="auditCtrl.runningFrameworkLevelAuditId">: {{auditCtrl.runAllAuditProgress.ran}}/{{auditCtrl.runAllAuditProgress.total}}
          <ng-container *ngIf="auditCtrl.runAllAuditProgress.skipped"> (skipped {{auditCtrl.runAllAuditProgress.skipped}} already run)</ng-container>
        </ng-container>
      </div>
    </div>
    <div class="modal-actions">
      <fieldset [disabled]="auditCtrl.runningFrameworkLevelAuditId">
        <div class="audit-options-setting">
          <label class="audit-options-label">
            <input type="checkbox" [(ngModel)]="runAsync" class="audit-options-checkbox" />
            <span><tra slug="lbl_all"></tra></span>
          </label>
          <label class="audit-options-label">
            <input type="checkbox" [(ngModel)]="runInChain" class="audit-options-checkbox" />
            <span>Chain (one at a time)</span>
          </label>
        </div>
        <div class="audit-options-since">
          <label class="audit-options-label" style="flex-direction: column;">
            <span>Only if not run since:</span>
            <input type="datetime-local" [(ngModel)]="sinceLocal" />
          </label>
        </div>
        <div style="align-items: flex-end;">
          <span class="audit-options-due">{{ auditsDueCount }} due</span>
        </div>
  
        <div class="audit-options-buttons">
          <button
            (click)="runAllAudits()"
            class="button is-small has-icon audit-options-run-btn"
            [class.is-info]="auditCtrl.runningFrameworkLevelAuditId"
          >
            <ng-container *ngIf="auditCtrl.runningFrameworkLevelAuditId; else runAuditBtn">
              <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
            </ng-container>
            <ng-template #runAuditBtn>
              <tra slug="ie_run_audit"></tra>
            </ng-template>
          </button>
  
          <button
            (click)="pageModal.closeModal()"
            class="button is-small is-info audit-options-close-btn"
          >
            <tra slug="btn_close"></tra>
          </button>
        </div>
      </fieldset>
    </div>
  </div>
</div>